import * as React from "react";

import "./added-codes.scss";

import {apiArray}       from "@Common/logic/api-array";
import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {UseState}       from "@Common/react/use-state";
import {formatMoney}    from "@Common/ui-components/language/format-money";

import {CheckShowPricing} from "@Xpresso/routes/common/check-show-pricing";

import {removePromoCode} from "./remove-promo-code";

export const AddedCodes = ({store}) => cs(
    consumeContext("apis"),
    ["promoCodes", (_, next) => next(apiArray(store.cart?.appliedCredits?.promoCodes))],
    ({promoCodes}, next) => !!promoCodes?.length && next(),
    ({}, next) => (
        <div className="added-codes" >
            {next()}
        </div>
    ),
    ({promoCodes, apis}) => promoCodes.map((pc, i) => (
        <div className="line" key={i}>
            <div className="code" xd-qa-type="label" xd-qa-name={pc.code}>
                {pc.code}

                {cs(
                    ({}, next) => CheckShowPricing({next}),
                    () => <>
                        {" "}-{" "}
                        {formatMoney(pc.amount)}
                    </>
                )}
                {" - "}
                {pc.itemId}
            </div>

            {cs(
                ["removing", (_, next) => UseState({next})],
                ({removing}) => (
                    <img
                        src={require("./error.png")}
                        alt="Remove code"
                        onClick={async () => {
                            if (removing.value) {
                                return;
                            }

                            removing.onChange(true);
                            await store.dispatch(removePromoCode(pc, {apis}));
                            removing.onChange(false);
                        }}
                        xd-qa-type="button"
                        xd-qa-name={"Remove Code " + pc.code}
                    />
                )
            )}
        </div>
    ))
);
